// device breakpoint (naming from semantic-ui)
import { breakpointsNumber } from '../styles';

// aligning with styles variables
// ideally, remove this and use the styles variables - lot of work
const mobileBreakpoint = breakpointsNumber.mobile;
const wideMobileBreakpoint = breakpointsNumber.wideMobile;
const tabletBreakpoint = breakpointsNumber.tablet;
const computerBreakpoint = breakpointsNumber.computer;
const largeTabletBreakpoint = breakpointsNumber.largeTablet;
const largeMonitorBreakpoint = breakpointsNumber.largeMonitor;
const widescreenMonitorBreakpoint = breakpointsNumber.widescreenMonitor;

export {
  mobileBreakpoint,
  wideMobileBreakpoint,
  tabletBreakpoint,
  computerBreakpoint,
  largeTabletBreakpoint,
  largeMonitorBreakpoint,
  widescreenMonitorBreakpoint
};



// WEBPACK FOOTER //
// ./src/utils/breakpoints.js